import { render, staticRenderFns } from "./LeadFormDesktop.vue?vue&type=template&id=456a6c6f&scoped=true"
import script from "./LeadFormDesktop.vue?vue&type=script&lang=js"
export * from "./LeadFormDesktop.vue?vue&type=script&lang=js"
import style0 from "./LeadFormDesktop.vue?vue&type=style&index=0&id=456a6c6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a6c6f",
  null
  
)

export default component.exports